import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import BoxInscription from '../../../../Components/BoxInscription'
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/atoms/Button'
import Font from '../../../../../SPRINTA/atoms/Font'
import T from '../../../../../SPRINTA/translate/T'

import css from './style.module.css'
class Events extends Component {
      state = {
            loading: true,
            data: [],
            total: 0,
            loadingMore: false
      }

      componentWillMount() {
            this.componentWillReceiveProps(this.props, true)  
      }

      componentWillReceiveProps(nextProps) {
            if(!nextProps.userData.isMe) {
                  this.props.history.push('/user/'+(nextProps.userData.profile.username || nextProps.userData.profile.username))
            }

            if(this.username !== nextProps.userData.profile.username && this.username !== nextProps.userData.profile.token) {
                  this.setState({
                        loading: true,
                        data: []
                  }, () => {
                        this.loadData(nextProps.username)
                  })
                  this.username = nextProps.userData.profile.username || nextProps.userData.profile.token
            }

            if(this.props.match.params.filter !== nextProps.match.params.filter) {
                  this.setState({
                        loading: true,
                        data: []
                  })
                  this.loadData(this.props.username, 0, 8, nextProps.match.params.filter)
            }
      }

      loadData(username, start = 0, limit = 8, type = this.props.match.params.filter) {
            this.setState({
                  loadingMore: true
            })

            let promise = null
            if(type === 'experiences')
            promise = user.subscriptionExperiences(start, limit)
            else
            promise = user.inscriptions(username, start, limit)

            promise
            .then(resp => {
                  if(type === 'experiences') {
                        resp.result.list.forEach(i => {
                              if(i.status === 'PD')
                              i.status = '1'

                              if(['CC', 'RV'].indexOf(i.status) > -1)
                              i.status = '0'

                              if(['CF', 'RL'].indexOf(i.status) > -1)
                              i.status = '3'
                        })
                  }


                  this.setState({
                        loading: false,
                        total: resp.result.total,
                        data: [
                              ...this.state.data,
                              ...resp.result.list
                        ],
                        loadingMore: false
                  })
            })
      }

      loadMoreData() {
            this.setState({
                  loadingMore: true
            })

            this.loadData(this.props.username, this.state.data.length)
      }

      cancelled(token) {
            let data = this.state.data.filter(i => i.token !== token)
            this.setState({
                  data: [...data]
            })
      }

   render() {
            let type = this.props.match.params.filter
            return (
                  <Container style={{paddingBottom: '30px', paddingTop: '30px'}}>
                        <Row style={{ marginBottom: '30px' }}>
                              <Col size='12 6'>
                                    <Font heading="3" color='#666' weight='100'>
                                          {T.text('my_inscriptions_b')}
                                    </Font>
                              </Col>
                              <Col size='12 6' text='left right'>
                                    <Row>
                                          <ul className={css.filter}>
                                                <li className={!type || type === 'events' ? css.active : null}><RouterLink to={`/user/${this.props.match.params.user}/inscriptions/events`}>Eventos</RouterLink></li>
                                                <li className={type === 'experiences' ? css.active : null}><RouterLink to={`/user/${this.props.match.params.user}/inscriptions/experiences`}>Experiências</RouterLink></li>
                                          </ul>
                                    </Row>
                              </Col>
                        </Row>

                        {this.state.loading ? (
                              <Row>
                                    <Col>
                                          <Row>
                                                <Col size='12 6'>
                                                      <Placeholder type='retangle' style={{marginTop: '20px', height: '400px'}} />
                                                </Col>
                                                <Col size='12 6'>
                                                      <Placeholder type='retangle' style={{marginTop: '20px', height: '400px'}} />
                                                </Col>
                                          </Row>
                                          <br />
                                    </Col>
                              </Row>
                        ) : (
                              <Row>
                                    {this.state.data.length > 0 ? this.state.data.map(item => 
                                          <Col size='12 6' key={item.subscriptionId || item.id} style={{marginBottom: '30px'}}>
                                                {type === 'experiences' ? (
                                                      <BoxInscription
                                                            type='experience'
                                                            event={{
                                                                  cover: '',
                                                                  title: item.eventTitle,
                                                                  city: item.eventCity,
                                                                  state_abbreviation: item.eventRegion,
                                                                  date: item.athletes[0] ? item.athletes[0].date : null,
                                                                  time: item.athletes[0] ? item.athletes[0].time : null,
                                                            }}
                                                            link={`${window.URL_CHECKOUT}${parseInt(item.paymentStatus, 10) >= 3 ? 'voucher/' : ''}${item.token}`}
                                                            status={item.paymentStatus}
                                                            cancelled={token => this.cancelled(token)}
                                                            token={item.token}
                                                            inscriptionDate={item.subscriptionDate}
                                                            athletes={item.athletes}
                                                      />
                                                ) : (
                                                      <BoxInscription
                                                            type={item.eventKind}
                                                            event={{
                                                                  cover: '',
                                                                  title: item.eventTitle,
                                                                  city: item.eventCity,
                                                                  state_abbreviation: item.eventRegion,
                                                                  date: item.eventStartDate
                                                            }}
                                                            cancelled={token => this.cancelled(token)}
                                                            link={`${window.URL_CHECKOUT}${parseInt(item.paymentStatus, 10) >= 3 ? 'voucher/' : ''}${item.token}`}
                                                            name={item.name}
                                                            team={item.team}
                                                            status={item.paymentStatus}
                                                            token={item.token}
                                                            inscriptionDate={item.subscriptionDate}
                                                            athletes={item.athletes}
                                                      />
                                                )}
                                                
                                          </Col>
                                    ) : (
                                          <Col size='12' text='center' style={{ fontSize: '14px' }}>
                                                Você ainda não esta inscrito em nenhum experiência
                                          </Col>
                                    )}
                              </Row>
                        )}

                        {this.state.data.length < this.state.total && (
                              <Col text='center' style={{marginTop: '30px'}}>
                                    {!this.state.loadingMore ? (
                                          <Button
                                          inline
                                          theme='primary'
                                          onClick={() => this.loadMoreData()}>
                                                {T.text('load_more')}
                                          </Button>
                                    ) : (
                                          <Loading />    
                                    )}
                              </Col>
                        )}
                  </Container>
            )
      }
}

const mapStateToProps = store => ({
   user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Events)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Inscriptions/index.js